<template>
    <div class="is-flex is-align-items-center is-justify-content-flex-start" style="gap: 8px; flex-wrap: wrap;">
        <div class="is-flex is-align-items-center" style="flex-shrink: 0;">
            <template v-for="item in ['en', 'fr', 'de_DE']">
                <button @click="changeLocale(item)">
                    <gb-flag
                        v-if="item"
                        :code="getFlag(item)"
                        :class="{ 'is-selected' : item === locale }"
                        size="small"
                        iconPath="/assets/img/flags/"
                    />
                </button>
            </template>
        </div>
        <div v-if="settings.crud && settings.crud.mergeStatus" class="is-flex is-align-items-center" style="gap: 4px; flex-shrink: 0;">
            <span
                class="merge-status is-buspaket"
                :class="{ 'is-inactive': sourceFilterValue !== 'buspaket' }"
                @click="sourceFilterValue = 'buspaket'"
                style="cursor: pointer;"
                title="Buspaket/WE Tours"
            >B</span>
            <span
                class="merge-status is-welcome"
                :class="{ 'is-inactive': sourceFilterValue !== 'welcome' }"
                @click="sourceFilterValue = 'welcome'"
                style="cursor: pointer;"
                title="Welcome Tours"
            >W</span>
        </div>

        <email-template-select
            v-model    = "templateSelected"
            :templates-filtered="templates"
            style="max-width:350px; flex: 1; min-width: 150px;"
        />

        <multiselect
            v-if="templateSelected && templateSelected.variants.length > 0"
            v-model         = "variantSelected"
            v-bind:options  = "templateSelected.variants"
            label          = "name"
            v-bind:custom-label = "variant => variant.personal ? variant.name + ' (meine Fassung)' : variant.name"
            track-by       = "id"
            :max-height="600"
            style="max-width:350px; flex: 1; min-width: 150px;"
        />

        <toggle-switch
            v-model="isFormal"
            v-if="settings.emails.isFormal[emailType]"
            btn-style="height: 35px"
            class="mb-0"
            style="margin-right: 10px"
        >
            <option :value="false">Du</option>
            <option :value="true">Sie</option>
        </toggle-switch>

        <button v-on:click.prevent.stop="fillEmail" class="button is-large is-icon" style="height: 35px" title="Template neu laden">
            <i class="material-icons">loop</i>
        </button>
    </div>
</template>



<script>
import { getFlag } from '@utilities/functions';
import { Multiselect, ToggleSwitch } from '@components/form';
import EmailTemplateSelect from '@components/form/EmailTemplateSelect';
import { settings } from '@clientSpecific/utilities/settings';
import store from '../../store';


/*
 * Vorlagen-Zeile des Email-Modals (Sprache, Buspaket/Welcome-Filter, Template,
 * Variante, Du/Sie, Reload) — geteilt von EmailForm (Einzel-Email) und
 * BulkEmailForm (Massenemail). Der State lebt komplett im Email-Store.
 */
export default {
    store: store,
    props: {
        //für die automatische Sprach-Vorauswahl nach Provider-/Kunden-Hauptsprache (Einzel-Flow)
        preselectedRequest: { default: null },
        preselectedOrder:   { default: null }
    },

    data: function () {
        return {
            settings: settings,
            localeIsSetByUser: false
        }
    },

    computed: {
        emailType: function () {
            return this.$store.state.emailType;
        },

        ordersSelected: function () {
            return this.$store.state.ordersSelected;
        },

        isFormal: {
            get: function () {
                return this.$store.state.isFormal;
            },
            set: function (value) {
                this.$store.state.isFormal = value;
                this.$store.dispatch('resetTemplates');
            }
        },

        locale: {
            get: function () {
                if (!this.localeIsSetByUser) {
                    let availableTranslations = settings.voucher.availableTranslations;
                    const providerLanguage = this.preselectedRequest && this.preselectedRequest.provider
                        ? this.preselectedRequest.provider.mainLanguage : null;
                    const clientLanguage = this.preselectedOrder && this.preselectedOrder.client
                        ? this.preselectedOrder.client.mainLanguage : null;

                    if (this.emailType === 'provider' && providerLanguage && availableTranslations.includes(providerLanguage)) {
                        this.$store.state.localeSelected = providerLanguage;
                        return providerLanguage;
                    }
                    if (this.emailType === 'client' && clientLanguage && availableTranslations.includes(clientLanguage)) {
                        this.$store.state.localeSelected = clientLanguage;
                        return clientLanguage;
                    }
                }
                return this.$store.state.localeSelected;
            },
            set: function (value) {
                this.localeIsSetByUser = true;
                this.$store.state.localeSelected = value;
                this.$store.dispatch('resetTemplates', null, true);
            }
        },

        templates: function () {
            let formal = this.isFormal ? 'formal' : 'informal';
            return this.$store.state.templates[this.emailType][this.locale][formal];
        },

        templateSelected: {
            get: function () {
                return this.$store.state.templateSelected;
            },
            set: function (value) {
                this.$store.state.templateSelected = value;
                this.variantSelected = value.variants.find(item => item.variantStandard);
            }
        },

        variantSelected: {
            get: function () {
                return this.$store.state.variantSelected;
            },
            set: function (value) {
                this.$store.state.variantSelected = value;
                this.$store.dispatch('fillEmailBody');
            }
        },

        sourceFilterValue: {
            get: function () {
                return this.$store.state.sourceFilter.length > 0 ? this.$store.state.sourceFilter[0] : null;
            },
            set: function (value) {
                this.$store.state.sourceFilter = value ? [value] : [];
                this.$store.state._templateCache = {};
                this.$store.dispatch('resetTemplates');
            }
        }
    },

    methods: {
        getFlag,

        fillEmail: function () {
            this.$store.dispatch('fillEmailBody');
        },

        changeLocale: function (newValue) {
            this.locale = newValue;
        }
    },

    watch: {
        //Buspaket/Welcome-Quellfilter nach Organisation des (ersten) Auftrags vorbelegen
        ordersSelected: {
            handler: function (newVal) {
                if (this.settings.crud && this.settings.crud.mergeStatus && newVal && newVal.length > 0 && this.$store.state.sourceFilter.length === 0) {
                    const orgId = newVal[0].organisationFilter?.id;
                    if (orgId === 1 || orgId === 2) {
                        this.$store.state.sourceFilter = ['buspaket'];
                    } else {
                        this.$store.state.sourceFilter = ['welcome'];
                    }
                }
            },
            immediate: true
        }
    },

    components: {
        EmailTemplateSelect,
        Multiselect,
        ToggleSwitch
    }
}
</script>
